import { Box, Typography } from "@material-ui/core";
import React, { ReactNode } from "react";

interface MenuProps {
  children?: ReactNode;
}

export const Menu: React.FC<MenuProps> = ({ children }) => {
  return (
    <Typography variant="body2" component="nav" role="navigation">
      <Box component="ul" display="column" m={0} p={0}>
        {children}
      </Box>
    </Typography>
  );
};
